module.exports = __webpack_public_path__ + "img/title.a9f71459.png";